// Game Service for fetching game ank data
const API_BASE_URL = 'https://backend.mainbazar777.site/api';

/**
 * Fetch game ank data with all digit types
 * @returns {Promise} Object containing parsed digit arrays
 */
export const fetchGameAnkData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/game-ank`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!data.game_ank || !data.game_ank[0]) {
      throw new Error('Invalid game ank data structure');
    }

    const gameData = data.game_ank[0];
    const parsedData = {};

    // Parse each digit type from JSON string to array
    const digitTypes = [
      'single_digit',
      'jodi_digit',
      'single_panna',
      'double_panna',
      'half_sangam_open_digit',
      'half_sangam_close_pana',
      'triple_panna',
      'full_sangam_open_ank',
      'full_sangam_close_ank'
    ];

    digitTypes.forEach(type => {
      if (gameData[type]) {
        try {
          parsedData[type] = typeof gameData[type] === 'string' 
            ? JSON.parse(gameData[type]) 
            : gameData[type];
        } catch (e) {
          console.error(`Error parsing ${type}:`, e);
          parsedData[type] = [];
        }
      }
    });

    return parsedData;
  } catch (error) {
    console.error('Error fetching game ank data:', error);
    throw new Error(`Failed to fetch game data: ${error.message}`);
  }
};

/**
 * Get specific digit type data
 * @param {string} digitType - Type of digit (single_panna, double_panna, etc.)
 * @returns {Promise} Array of digits
 */
export const getDigitsByType = async (digitType) => {
  try {
    const gameData = await fetchGameAnkData();
    return gameData[digitType] || [];
  } catch (error) {
    console.error(`Error getting ${digitType}:`, error);
    return [];
  }
};
